module.exports = __webpack_public_path__ + "static/media/attendSalesUp1.0af0db23.svg";